// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAUFFQiGNod7auV3lqX_7JdAh2gIcviNb8",
  authDomain: "digital-silo.firebaseapp.com",
  projectId: "digital-silo",
  storageBucket: "digital-silo.firebasestorage.app",
  messagingSenderId: "796041935492",
  appId: "1:796041935492:web:91d84ac630790c1d82e0d1",
  measurementId: "G-ZV4466QG7J"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);